module.exports = __webpack_public_path__ + "img/selected2-min.22b9c4f3.png";